export default {
  title: 'Real Estate Sales Dynamics',
  x_axis: 'Date',
  y_axis: 'Number of Sales',
  districts: {
    alanya: 'Alanya',
    konyaalti: 'Konyaaltı',
    kemer: 'Kemer',
    kepez: 'Kepez',
    dosemealti: 'Döşemealtı',
    finike: 'Finike'
  }
}